
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tennis/region/[regionSlug]",
      function () {
        return require("private-next-pages/tennis/region/[regionSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tennis/region/[regionSlug]"])
      });
    }
  